import shared from "servicestack/auto-query/auto-query.config.es6"; //get shared

export default Object.assign(shared, {
  hideEmptyGroupings: true,
  hideGroupingCounts: true,
  shoppingSearchTop: true,
  maxPanelHeight: "300px",
  retainQueryStringHistory: true,
});
